import { DateTime as LuxonDateTime } from 'luxon';

interface RequestableDay {
  date: string;
}

export function getRequestableDaysForFrequency<T extends RequestableDay>(
  requestableDays: T[],
  frequency: string,
  currentDateTime: LuxonDateTime
): T[] {
  if (frequency === 'once') {
    return requestableDays;
  }

  const currentDate = currentDateTime.toISODate();
  return requestableDays.filter(day => day.date > currentDate);
}

// Day selections are addressed by index, so callers need today's position in the
// filtered list rather than assuming it is 0.
export function findTodayIndex<T extends RequestableDay>(
  requestableDays: T[],
  currentDateTime: LuxonDateTime
): number {
  const currentDate = currentDateTime.toISODate();
  return requestableDays.findIndex(day => day.date === currentDate);
}
